<div class="container testimonials">
    <h2>Das sagen Andere über uns</h2>
    <div class="carousel">
        <ngb-carousel>
            <ng-template ngbSlide *ngFor="let item of testimonials">
                <qloc-theme-testimonial [text]="item.text" [name]="item.name" [avatar]="item.avatar" [info]="item.info"></qloc-theme-testimonial>
            </ng-template>
        </ngb-carousel>
    </div>
</div>